




























































































import { Component, Model, Vue } from "vue-property-decorator";
//import { mapState } from "vuex";
import { FileFilter } from "@/store/modules/types";
import { BNavItemDropdown, BDropdownItem, BPopover } from "bootstrap-vue";

@Component({
    //computed: mapState("gaps", ["insurers"])
    components: {
        BNavItemDropdown,
        BDropdownItem,
        BPopover,
    },
})
export default class FileUpload extends Vue {
    @Model("change") readonly filter!: FileFilter;
    files: any = [];
    comment: String = "";
    show = true;

    async uploadFiles() {
        this.$store.commit("main/SET_LOADING", true);
        try {
            const fileKeys = await this.$store.dispatch("schedule/uploadFiles", this.files);

            var data = {
                fileKey: fileKeys.join(),
                comments: this.comment
            }

            await this.$store.dispatch("schedule/saveFile", data);
            this.files = [];
            this.resetInputFile();
            this.$emit('refresh');

        } catch (error) {
            console.log(error);
        } finally {
            this.$store.commit("main/SET_LOADING", false);
        }
    }

    close() {
        this.$root.$emit("bv::hide::popover");
    }
    deleteFile(index) {
        this.files.splice(index, 1);
        this.resetInputFile();
    }

    resetInputFile() {
        this.$refs["inputFile"]["value"] = "";
    }

    containsFile(obj, list) {
        var i;
        for (i = 0; i < list.length; i++) {
            if (list[i].name === obj.name) {
                return true;
            }
        }

        return false;
    }

    isValidFile(ext) {
        ext = ext.toLowerCase();
        if (ext == "jar" || ext == "exe") {
            return false;
        }
        return true;
    }

    onFileChange(e) {
        for (var i = 0; i < e.target.files.length; i++) {
            if (!this.containsFile(e.target.files[i], this.files) && this.isValidFile(e.target.files[i].name.split(".").pop()))
                this.files.push(e.target.files[i]);
        }
    }

    drop(e) {
        for (var i = 0; i < e.dataTransfer.files.length; i++) {
            if (!this.containsFile(e.dataTransfer.files[i], this.files) && this.isValidFile(e.dataTransfer.files[i].name.split(".").pop()))
                this.files.push(e.dataTransfer.files[i]);
        }
    }
}
